import type { ReactNode } from 'react'
import { View } from 'react-native'

import { Chip } from '@/src/elements/chip'
import { COMMUNITY_LIFETIME } from '@/src/features/community/models/community.constants'
import { CommunityMembersChip } from '@/src/features/community/ui/components/CommunityMembersChip'
import { CommunityNbDaysChip } from '@/src/features/community/ui/components/CommunityNbDaysChip'
import {
  CommunityActivityChip,
  type TCommunityActivityChipProps,
} from '@/src/features/community/ui/components/CommunityStatusSection/CommunityActivityChip'
import { ICON } from '@/src/general/enums/icons'
import { useTranslate } from '@/src/lang/useTranslate'

import type { TMediumCommunityApi } from '../../../api/communityApi.types'

export type TCommunityStatusSectionProps = {
  community: Pick<TMediumCommunityApi, 'fromDate' | 'toDate' | 'lifetime' | 'isPrivate' | 'nbMembers'> &
    TCommunityActivityChipProps['community']
} & Omit<TCommunityActivityChipProps, 'community'>

export const CommunityStatusSection = ({
  community,
  subscription,
  ...otherProps
}: TCommunityStatusSectionProps): ReactNode => {
  const { lifetime, nbMembers, isPrivate } = community

  const { t } = useTranslate()

  return (
    <View className="flex flex-row gap-2 items-center max-w-full flex-wrap">
      {lifetime === COMMUNITY_LIFETIME.NOVENA && (
        <Chip text={t('user.wizard.novena')} colors="default" variant="flat" style={{ maxWidth: 'auto' }} />
      )}
      {lifetime === COMMUNITY_LIFETIME.RETREAT && <CommunityNbDaysChip community={community} fontWeight="bold" />}
      {isPrivate && (
        <Chip text={t('community.private.private')} iconName={ICON.INCOGNITO} colors="default" variant="flat" />
      )}
      <View className="flex-row gap-2">
        {typeof nbMembers === 'number' && (
          <CommunityMembersChip nbMembers={nbMembers} fontWeight="bold" transparent={false} />
        )}
      </View>
      <CommunityActivityChip
        community={community}
        subscription={subscription}
        colors="default"
        fontWeight="bold"
        {...otherProps}
      />
    </View>
  )
}
